module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('main', [_c('v-content', [_c('v-container', [_c('v-row', [_c('v-col', {
    staticStyle: {
      "margin": "10rem auto"
    },
    attrs: {
      "md6": "md6",
      "xs12": "xs12"
    }
  }, [_c('div', {
    staticClass: "display-3 mb-5"
  }, [_vm._v(_vm._s(_vm.welcome))]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.error.show) ? _c('div', [_c('v-alert', {
    staticClass: "mb-5",
    attrs: {
      "error": "",
      "value": true
    }
  }, [_vm._v(_vm._s(_vm.error.message))])], 1) : _vm._e()]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Email"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.logIn($event)
      }
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Password",
      "type": "password"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.logIn($event)
      }
    },
    model: {
      value: (_vm.passw),
      callback: function($$v) {
        _vm.passw = $$v
      },
      expression: "passw"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center"
  }, [_c('v-btn', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.logIn($event)
      }
    }
  }, [_vm._v("Login")]), _vm._v(" "), _c('p', {
    staticClass: "mt-3"
  }, [_vm._v("Non hai ancora un account? "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Signup'
      }
    }
  }, [_vm._v("Iscriviti")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58bae7bc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 122
// module chunks = 1